import { Navigate, type RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Diagnosis from "../pages/diagnosis/page";
import Compare from "../pages/compare/page";
import BillCheck from "../pages/bill-check/page";
import Articles from "../pages/articles/page";
import ArticleDetail from "../pages/articles/detail";
import About from "../pages/about/page";
import Policy from "../pages/policy/page";
import Privacy from "../pages/privacy/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/diagnosis", element: <Diagnosis /> },
  { path: "/compare", element: <Compare /> },
  { path: "/bill-check", element: <BillCheck /> },
  { path: "/articles", element: <Articles /> },
  { path: "/articles/:id", element: <ArticleDetail /> },
  { path: "/about", element: <About /> },
  { path: "/policy", element: <Policy /> },
  { path: "/privacy", element: <Privacy /> },
  { path: "/contact", element: <Contact /> },
  { path: "/index.html", element: <Navigate to="/" replace /> },
  { path: "/diagnosis.html", element: <Navigate to="/diagnosis" replace /> },
  { path: "/compare.html", element: <Navigate to="/compare" replace /> },
  { path: "/about.html", element: <Navigate to="/about" replace /> },
  { path: "/contact.html", element: <Navigate to="/contact" replace /> },
  { path: "/privacy.html", element: <Navigate to="/privacy" replace /> },
  { path: "/tools/bill.html", element: <Navigate to="/bill-check" replace /> },
  { path: "/guide/bill-basics.html", element: <Navigate to="/articles/bill-basics" replace /> },
  { path: "/guide/before-switching.html", element: <Navigate to="/articles/before-switching" replace /> },
  { path: "/guide/data-usage.html", element: <Navigate to="/articles/data-usage" replace /> },
  { path: "/guide/ahamo.html", element: <Navigate to="/articles/ahamo-guide" replace /> },
  { path: "/guide/iijmio.html", element: <Navigate to="/articles/iijmio-guide" replace /> },
  { path: "/guide/rakuten.html", element: <Navigate to="/articles/rakuten-guide" replace /> },
  { path: "/guide/iphone-buy.html", element: <Navigate to="/articles/iphone-buy" replace /> },
  { path: "/guide/iphone-repair-or-replace.html", element: <Navigate to="/articles/iphone-repair-or-replace" replace /> },
  { path: "/guide/used-iphone-checklist.html", element: <Navigate to="/articles/used-iphone-checklist" replace /> },
  { path: "/homepage-v3-preview.html", element: <Navigate to="/" replace /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
